import FocusMode from './FocusMode';
import NotesPanel from './NotesPanel';
import QuickCapture from './QuickCapture';
import QuickAddModal from './QuickAddModal';
import SearchOverlay from './SearchOverlay';
import CommandBar from './CommandBar';
import ShortcutsModal from './ShortcutsModal';
import AIRewriteMenu from './AIRewriteMenu';
import PWABanners from './PWABanners';
import DaybreakModal from './daybreak/DaybreakModal';
import MobileAiCaptureFab from './MobileAiCaptureFab';

/**
 * The full overlay stack mounted once at the app shell root —
 * focus mode, notes drawer, quick capture, ⌘K palette, search,
 * shortcuts cheat-sheet, AI rewrite popover, PWA banners,
 * daybreak ritual and the mobile AI capture FAB.
 */
export function AppOverlays({
  focusTask, setFocusTask,
  notesOpen, setNotesOpen,
  commandBarOpen, setCommandBarOpen,
  searchOpen, setSearchOpen,
  shortcutsOpen, setShortcutsOpen,
  daybreakOpen, onDaybreakClose,
  quickAddOpen, onQuickAddClose,
  quickAddBrainDump,
}) {
  return (
    <>
      {focusTask ? (
        <FocusMode
          task={focusTask}
          onClose={() => setFocusTask(null)}
          onComplete={() => setFocusTask(null)}
        />
      ) : null}
      <NotesPanel isOpen={notesOpen} onClose={() => setNotesOpen(false)} />
      <QuickCapture />
      <QuickAddModal open={quickAddOpen} onClose={onQuickAddClose} initialBrainDump={quickAddBrainDump} />
      <CommandBar isOpen={commandBarOpen} onClose={() => setCommandBarOpen(false)} />
      <SearchOverlay isOpen={searchOpen} onClose={() => setSearchOpen(false)} />
      <ShortcutsModal isOpen={shortcutsOpen} onClose={() => setShortcutsOpen(false)} />
      <AIRewriteMenu />
      <PWABanners />
      <DaybreakModal open={daybreakOpen} onClose={onDaybreakClose} />
      <MobileAiCaptureFab />
    </>
  );
}
